import type { UseMutationResult } from '@tanstack/react-query'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { COMMENT_API_PREFIX } from 'shared/api/constants/api-constants'
import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import type { UseMutationClearOptions } from 'shared/types/tanstack-utility-types'
import { commentsKeys } from 'modules/comments/api/key-factory'
import { CommentsTypeEnum } from 'modules/comments/types'

interface UsePinCommentOptions extends UseMutationClearOptions<void, Error, void> {
  commentId: number
  pageId: number
}

export const usePinComment = ({
  commentId,
  pageId,
  ...options
}: UsePinCommentOptions): UseMutationResult<void, Error, void> => {
  const queryClient = useQueryClient()
  const { fetcher } = useApiWrapperWithErrorValidation<RequestMethodsEnum.post, void, void>({
    method: RequestMethodsEnum.post,
    notFoundResponseHandler() {},
  })

  return useMutation({
    mutationFn: () => fetcher(`${COMMENT_API_PREFIX}/${commentId}/pin`),
    ...options,
    onSuccess: async (...args) => {
      await queryClient.invalidateQueries({
        queryKey: commentsKeys.resource(CommentsTypeEnum.Community, pageId),
      })
      await options.onSuccess?.(...args)
    },
  })
}
